export default "__VITE_ASSET__BRK1jFU6__"